import { some } from 'lodash';

import {
  consortiaFieldsToMaskMap,
  fieldsToSearchOptionMap,
} from '../../constants';
import { createCqlAdvancedSearchQuery } from '../createAdvancedSearchQuery';
import { parseMaskedAdvancedSearchQuery } from '../parseMaskedAdvancedSearchQuery';

export const transformMaskedQueryToCql = ({
  query,
  isConsortiaMode,
}: {
  query: string;
  isConsortiaMode?: boolean;
}): string => {
  const searchRows = parseMaskedAdvancedSearchQuery({
    query,
    isConsortiaMode,
  });
  const fieldMap = isConsortiaMode
    ? consortiaFieldsToMaskMap
    : fieldsToSearchOptionMap;
  const isQueryInvalid = some(searchRows, 'isInvalid');

  if (isQueryInvalid) {
    return query;
  }

  return createCqlAdvancedSearchQuery({ searchRows, fieldMap });
};
